import React, { useEffect, useState } from 'react'
import { GET_ALL_CANCELLATION_REASON_BY_TYPE } from '../../../../../../graphql/Catalog/CancellationReason/CancellationReason'
import { useMutation, useQuery } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import InputController from '../../../../../Global/InputController'
import * as Yup from 'yup'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import { CHANGE_STATUS_TO_ROUTE } from '../../../../../../graphql/Catalog/Trucks/Routes/routesTrucks'
import Box from '../../../../../Global/Box'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'

const ModalInterruptRoute = ({ routeId, statusId, refetch, setCloseModal }) => {
  const { showLoading, hideLoading } = useLoading()
  const [optionsReasons, setOptionsReasons] = useState([])

  const validationSchema = Yup.object().shape({
    reasonId: Yup.string().required('Campo requerido'),
    reason: Yup.string(),
  })

  const {
    methods,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const {
    loading: loadingReasons,
    error: errorReasons,
    data: dataReasons,
  } = useQuery(GET_ALL_CANCELLATION_REASON_BY_TYPE, {
    variables: {
      type: 'routes',
      limit: null,
      offset: null,
      searchQuery: null,
    },
    fetchPolicy: 'no-cache',
  })

  const [changeStatus] = useMutation(CHANGE_STATUS_TO_ROUTE)
  useEffect(() => {
    try {
      if (loadingReasons) return
      if (errorReasons)
        return toastSweetAlert({
          mode: 'error',
          message: errorReasons.message,
        })

      const cancelReasons = dataReasons.getAllCancellationReasonByType.rows.map(
        (reason) => {
          return {
            value: reason.id,
            label: reason.reason,
          }
        }
      )

      setOptionsReasons(cancelReasons)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataReasons, loadingReasons, errorReasons])

  const onSubmit = async (data) => {
    showLoading()
    try {
      const { data: dataUpdateStatus } = await changeStatus({
        variables: {
          changeStatusToRouteId: +routeId,
          statusId: statusId,
          reason: data.reason,
        },
      })

      if (dataUpdateStatus.changeStatusToRoute) {
        await refetch()
        return toastSweetAlert({
          mode: 'ok',
          message: 'Ruta interrumpida correctamente',
        })
      }
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
      setCloseModal(true)
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            withCard={false}
            btnSubmit
            btnSubmitText={'Interrumpir'}
            content={
              <>
                <div className="row">
                  <div className="col-lg-12 p-3">
                    <InputController
                      name="reasonId"
                      label="Motivo de interrupción"
                      control={control}
                      inputType="choosen"
                      options={optionsReasons}
                      placeholder="Selecciona un motivo de interrupción"
                      menuPosition="fixed"
                      changeAction={(e) => {
                        setValue('reason', e.label)
                      }}
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default ModalInterruptRoute
